<template>
    <div>
        <Pivot :statisticData="statisticData" :filter-default-values="filterDefaultValues" :filters="filters" :rows="rows" :values="values" :favourites="favourites" title="Contracts"></Pivot>
    </div>
</template>

<script>
import axios from 'axios'
import Pivot from '../../components/sandoz/Pivot.vue'

export default {
    
    data: () => ({
        statisticData: [],
        filters: [
            'language',
            'contract_status',
            'year',
            'type',
            'responsible_sales_person',
            'has_service',
            'has_marketing_activity',
            'region'
        ],
        rows: [
            'type',
            'contract_status_combined',
            'language',
        ],
        values: [
            {
                field: 'contract_no',
                function: 'count_unique'
            },
            {
                field: 'has_service',
                function: 'sum'
            },
            {
                field: 'has_marketing_activity',
                function: 'sum'
            },
            {
                field: 'year',
                function: 'count_unique'
            }
        ],
        favourites: [
            {
                name: 'Marketing Activities Total',
                filters: [
                  'year',
                  'type',
                  'contract_status'
                ],
                rows: [
                  'type',
                ],
                values: [
                    {
                        field: 'marketing_activities',
                        function: 'sum'
                    }
                ]
            }
        ],
        filterDefaultValues: [
            {
                year: 2022
            }
        ]
    }),

    components: {
        Pivot
    },

    mounted() {
        axios.get('/api/sandoz/statistics/contracts').then((response) => {
            this.statisticData = response.data
        })
    }
}
</script>
